import SecureRequest from "../utils/securerequest";

/**
 * Fetch a paginated list of notifications for a user.
 * @param {number|string} userId
 * @param {number} offset
 * @param {number} limit
 * @returns {Promise<Array>} list of notifications
 */
export async function getNotifications(userId, offset, limit) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const params = { offset, limit };
  return Request.get(`v3/notifications/${userId}`, { params });
}

/**
 * Mark specified notifications as read for a user.
 * @param {number|string} userId
 * @param {Array<number>} ids
 * @returns {Promise}
 */
export async function markNotificationsRead(userId, ids) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const body = { ids };
  return Request.patch(`v3/notifications/${userId}/read`, body);
}

/**
 * Mark all notifications as read for a user.
 * @param {number|string} userId
 * @returns {Promise}
 */
export async function markAllNotificationsRead(userId) {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const body = { all: true };
  return Request.patch(`v3/notifications/${userId}/read`, body);
}
